import axios from "axios";
function postArticle(title, content, date, imageIds) {
    return axios.post(`https://backsc.osc-fr1.scalingo.io/api/articles`,
        {
            "title": title,
            "content": content,
            "date": date,
            "images": imageIds
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function postFormateur(prenom, role, type, description) {
    return axios.post(`https://backsc.osc-fr1.scalingo.io/api/formateurss`,
        {
            "prenom": prenom.prenom,
            "role": prenom.role,
            "type": prenom.type,
            "description": prenom.description
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function putArticle(id, title, content, date) {
    return axios.put(`https://backsc.osc-fr1.scalingo.io/api/articles/` + id,
        {
            "title": title,
            "content": content,
            "date": date
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}
function postImages(image) {

    const formData = new FormData();
    formData.append("image_data", image); // Vous pouvez spécifier un nom de fichier

    try {
        return axios.post('https://backsc.osc-fr1.scalingo.io/api/images', formData, {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                // 'Content-Type': 'multipart/form-data', // Indique que nous envoyons un fichier
            }
        }).then((response) => {
            console.log(response.data);  // Should contain `message` and `id`
            const message = response.data.message;
            const id = response.data.id;
            console.log(message, id);
            return id
        })
    } catch (error) {
        console.error("Error uploading image:", error);
    }
}

function fetchArticleById(id) {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/articles/` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function fetchArticles() {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/articles`, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function fetchFormateurs() {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/formateurss`, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function deleteFormateurs(id) {
    return axios.delete(`https://backsc.osc-fr1.scalingo.io/api/formateurss/` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function fetchImageById(id) {
    const modifiedId = id.replace('/api/imagess', '');
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/images` + modifiedId, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function deleteArticle(id) {
    return axios.delete(`https://backsc.osc-fr1.scalingo.io/api/articles/` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function putAccueil(accueil) {
    return axios.put(`https://backsc.osc-fr1.scalingo.io/api/accueils/1`,
        {
            "annee": accueil.annee,
            "formations": accueil.formations,
            "formateurs": accueil.formateurs,
            "formes": accueil.formes,
            "representations": accueil.representations,
            "satisfaits": accueil.satisfaits,
            "commentaires": accueil.commentaires,
            "pseudo": accueil.pseudo,
            "description": accueil.description,
            "tauxReussites": accueil.tauxReussites,
            "anneeQuestion": accueil.anneeQuestion,
            "formationsQuestion": accueil.formationsQuestion,
            "formateursQuestion": accueil.formateursQuestion,
            "formesQuestion": accueil.formesQuestion,
            "representationsQuestion": accueil.representationsQuestion,
            "satisfaitsQuestion": accueil.satisfaitsQuestion,
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function getAccueil() {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/accueils/1`,
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function fetchAdresses() {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/coordonneess`,
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function postAddress(addresse) {
    return axios.post(`https://backsc.osc-fr1.scalingo.io/api/coordonneess`,
        {
            "adresse": addresse
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        })
}

function deleteAdddress(id) {
    return axios.delete(`https://backsc.osc-fr1.scalingo.io/api/coordonneess/` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

export default { postArticle, postImages, fetchArticleById, fetchArticles, fetchImageById, putArticle, deleteArticle, putAccueil, getAccueil, fetchFormateurs, postFormateur, deleteFormateurs, fetchAdresses, postAddress, deleteAdddress }
